import type { SimState } from './types';

export function normalizeSeed(seed: number): number {
  return (Math.trunc(seed) >>> 0) || 1;
}

/**
 * Menghasilkan angka float deterministik pada rentang [0, 1)
 * sekaligus memutasi state.rngState secara in-place.
 */
export function nextRandomFloat(state: Pick<SimState, 'rngState'>): number {
  const nextState = (state.rngState + 0x6d2b79f5) >>> 0;
  state.rngState = nextState;

  let t = nextState;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/**
 * Menghasilkan integer deterministik pada rentang inklusif [min, max].
 */
export function nextRandomInt(
  state: Pick<SimState, 'rngState'>,
  min: number,
  max: number
): number {
  const low = Math.ceil(min);
  const high = Math.floor(max);
  return Math.floor(nextRandomFloat(state) * (high - low + 1)) + low;
}

